import React, {useEffect} from 'react';
import {Col, ListGroup, Row} from "react-bootstrap";
// import ReceiverListItem from "./ReceiverListItem";
import Form from "react-bootstrap/Form";

const ReceiverList = ({
                        propList = undefined,
                        propSetList = undefined,
                        propUnreceivedList = undefined,
                        propSetUnreceivedList = undefined
                      }) => {

  /*
    useEffect(() => {
      console.log(propList);
    }, [propList]);
  */

  const alertClicked = (e) => {
    e.preventDefault();
    // 1. Make a shallow copy of the items
    let items = [...propList];
    // 2. Make a shallow copy of the item you want to mutate
    let item = {...items[e.target.dataset.index]};
    // 3. Replace the property you're intested in
    item.isSelected = !item.isSelected;
    // 4. Put it back into our array. N.B. we *are* mutating the array here,
    //    but that's why we made a copy first
    items[e.target.dataset.index] = item;
    // 5. Set the state to our new copy
    propSetList(items);
  };

  return (
      <Form.Group as={Row} controlId="receiver" className={""}>
        <Col md={3} className={"receiver-label-container"}>
          <Form.Label className={"label text-end fw-bold"} style={{}}>
            <span className={"text-danger"}>* </span>수신자
          </Form.Label>
        </Col>
        <Col md={9}>
          <Row className={""}>
            <Col md={5}>
              <h6 className={"label text-center"}>미수신</h6>
              <ListGroup>
                {Array.isArray(propList) ?
                    propList.map((item, idx) => {
                      if (!item.isSelected) {
                        return (
                            <ListGroup.Item
                                action
                                variant="dark"
                                onClick={alertClicked}
                                key={idx}
                                data-id={item.id}
                                data-selected={item.isSelected}
                                data-index={idx}
                            >
                              {item.name}({item.id})
                            </ListGroup.Item>
                        )
                      }
                    }) : ''}
              </ListGroup>
            </Col>
            <Col md={5}>
              <h6 className={"label text-center"}>수신</h6>
              <ListGroup>
                {Array.isArray(propList) ?
                    propList.map((item, idx) => {
                      if (item.isSelected) {
                        return (
                            <ListGroup.Item
                                action
                                variant="dark"
                                onClick={alertClicked}
                                key={idx}
                                data-id={item.id}
                                data-selected={item.isSelected}
                                data-index={idx}
                            >
                              {item.name}({item.id})
                            </ListGroup.Item>
                        )
                      }
                    }) : ''}
              </ListGroup>
            </Col>
          </Row>
        </Col>
      </Form.Group>
  );
};

export default ReceiverList;
